
import { Link } from "react-router-dom";


export default function ProfilCpte({profile, position, deleteClick}) {
    // states


    // comportements


    // Affichage
    return (
        <tr style={{borderStyle: "none"}}>
            <td className="text-center">{position + 1}</td>
            <td>{profile?.lib}</td>
            {/* <td>{profile.libparent ? profile?.libparent : ""}</td>
            <td>
                <div 
                    className={`badge mr-2 ${
                        (profile?.etat === 1) ? 'badge-warning' :
                        (profile?.etat === 2) ? 'badge-success' :
                        ''
                        }`
                    }>
                        {
                            (profile?.etat === 1) ? 'Non utilisé' : 
                            (profile?.etat === 2) ? 'Utilisé' : 
                            ''
                        }
                </div>
            </td>
            <td>{profile?.datecrea ? <ReactTimeAgo date={Date.parse(profile?.datecrea)} timeStyle="facebook" /> : ""}</td> */}
            <td className="text-center">
                <Link to={`/profile/${profile?.code}`} data-toggle="tooltip" title="consulter le profil" data-placement="left" className="btn-shadow-primary mr-2 ml-2 btn btn-sm btn-primary">
                    <i className="fa fa-eye"></i>
                </Link>
                <button onClick={deleteClick} data-toggle="tooltip" title="Désaffecter profil à ce compte"  className="btn-shadow-danger mr-2 ml-2 btn btn-sm btn-danger">
                    <i className="fa fa-trash"></i>
                </button>
            </td>
        </tr>
    )
}